import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { CanDeactivate } from "@angular/router";
import { Observable } from "rxjs";
import {
  CalenderAction,
  SubmitTimePromptComponent,
} from "../routes/time/time-sheet/week-picker/week-picker.component";
import { TimeTrackerService } from "../service/time-tracker.service";

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable({ providedIn: "root" })
export class UnsavedTimeSheetGuard implements CanDeactivate<ComponentCanDeactivate> {
  constructor(public dialog: MatDialog, private timeTrackerService: TimeTrackerService) {}

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    // if there are no pending changes, just allow deactivation; else confirm first
    return component.canDeactivate() ? true : this.openUnsavedTimeModal("CURR_WEEK");
  }

  openUnsavedTimeModal(calenderAction: CalenderAction): boolean {
    const dialogRef = this.dialog.open(SubmitTimePromptComponent, {
      width: "450px",
    });

    dialogRef.afterClosed().subscribe((result: string) => {
      switch (result) {
        case "NAVIGATE":
        case "DISCARD":
          switch (calenderAction) {
            case "CURR_WEEK":
              this.timeTrackerService.resetTimeSheet();
              break;
          }
          break;
        case "CLOSE":
          break;
      }
    });

    return false;
  }
}
